import Vue from 'vue'
import Vuex from 'vuex'
// 智慧党建
import ZHDJModule from './modules/ZHDJModule'
// 项目招商
import XMZSModule from './modules/XMZSModule'
// 园区动态
import YQDTModule from './modules/YQDTModule'
// 园区概况
import YQGKModule from './modules/YQGKModule'
//首页
import HomeModule from './modules/HomeModule'
//孵化服务
import FHFWModule from './modules/FHFWModule'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		company: company,
		companyAlias: companyAlias,
		Co: Co,
	},
	mutations: {},
	actions: {},
	modules: {
		// 智慧党建
		ZHDJ: ZHDJModule,
		// 项目招商
		XMZS: XMZSModule,
		// 园区动态
		YQDT: YQDTModule,
		// 园区概况
		YQGK: YQGKModule,
		//首页
		HOME: HomeModule,
		//孵化服务
		FHFW: FHFWModule,
	},
})
